import { action } from 'mobx';

import { AppManager, Input } from 'core/index';

import { TagsApp } from 'apps/tag/app';

import { PostApp } from 'apps/aggregator/app';
import { PostMutation } from 'apps/aggregator/gql';

export class PostFormAppManager extends AppManager {
  static registryName = 'PostFormAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.postFormApp = new PostApp(this, { tags: new TagsApp() });
    this.postFormApp.createForm();
    this.postFormInput = new Input({
      title: () => this.postFormApp.title,
      msg: () => this.postFormApp.msg,
      url: () => this.postFormApp.url,
      tags: () =>
        this.postFormApp.tags.map(({ id, name, deleted }) => ({
          id,
          name,
          deleted,
        })),
    });
  }

  @action Submit = options => {
    this.mutations.push(PostMutation.New(this.postFormInput, options));
  };
}
